<div class="organization-members-shell" :style="branding_style">
  <HomeNavBar @active-profile-loaded="set_active_profile" />

  <div class="p-2">
    <header class="d-flex gap-2 align-items-start mb-3">
      <button
        @click="$router.back()"
        class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
        type="button"
      >
        <i class="bi bi-chevron-left fs-5"></i>
      </button>

      <h4 class="fw-bold mb-0">{{ organization.company_name }} Members</h4>
    </header>

    <section class="organization-members-toolbar">
      <div class="organization-members-summary">
        <span>{{ organization_members.length }}</span>
        <p>Members in this organisation</p>
      </div>

      <div class="organization-members-toolbar-controls">
        <button
          class="btn btn-primary rounded text-xs px-4 fw-500"
          data-bs-toggle="modal"
          data-bs-target="#add_organization_member_modal"
          type="button"
          @click="reset_bulk_member_form"
        >
          <i class="bi bi-person-plus me-2 " aria-hidden="true"></i>
          <span>Add Member</span>
        </button>
      </div>
    </section>

    <section class="organization-members-stats">
      <div class="organization-stat-card">
        <div class="organization-stat-icon">
          <i class="bi bi-person-check"></i>
        </div>
        <div>
          <p>Active Members</p>
          <strong>{{ member_stats.active }}</strong>
        </div>
      </div>

      <div class="organization-stat-card">
        <div class="organization-stat-icon">
          <i class="bi bi-envelope-exclamation"></i>
        </div>
        <div>
          <p>Pending Invites</p>
          <strong>{{ member_stats.pending }}</strong>
        </div>
      </div>
    </section>

    <section class="organization-members-panel">
      <div v-if="is_loading_members" class="organization-members-empty">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Loading members...</p>
      </div>

      <div v-else-if="organization_members.length" class="organization-members-table-shell">
        <table id="organization-members-table" ref="organizationMembersTable" class="table table-hover align-middle organization-members-table w-100">
          <thead>
            <tr>
              <th>Member</th>
              <th>Email</th>
              <th>Status</th>
              <th v-if="can_manage_members" class="text-end d-none">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="member in organization_members" :key="member.id">
              <td>
                {{ member.first_name }} {{ member.last_name }}
              </td>
              <td>{{ member.email || 'No email available' }}</td>
              <td>
                {{ member.invitation_status }}
              </td>
              <td v-if="can_manage_members" class="text-end d-none">
                <div class="dropdown organization-member-menu">
                  <button class="btn btn-light btn-sm rounded border" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Manage member">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="open_manage_member(member)">
                        <i class="bi bi-sliders"></i>
                        Manage Access
                      </button>
                    </li>
                    <li>
                      <button class="dropdown-item text-danger text-xxs d-flex align-items-center gap-2" type="button" @click="remove_organization_member(member)">
                        <i class="bi bi-trash"></i>
                        Remove Member
                      </button>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="organization-members-empty">
        <i class="bi bi-people"></i>
        <h2>No members yet</h2>
        <p>Add users to give them access to this organisation workspace.</p>
      </div>
    </section>
  </div>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="invite_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="inviteOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="inviteOrganizationMemberLabel">Invite Organisation Member</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="invite_organization_member">
            <div class="modal-body">
              <div class="organization-member-modal-tabs" role="tablist" aria-label="Organisation member action">
                <button class="organization-member-modal-tab active" type="button" role="tab" aria-selected="true">
                  <i class="bi bi-envelope-plus" aria-hidden="true"></i>
                  <span>Invite</span>
                </button>
                <button class="organization-member-modal-tab" type="button" role="tab" aria-selected="false" @click="open_add_member_modal">
                  <i class="bi bi-person-plus" aria-hidden="true"></i>
                  <span>Add Members</span>
                </button>
              </div>

              <div v-if="invite_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ invite_errors.form }}
              </div>

              <div class="organization-invite-methods" role="group" aria-label="Invite method">
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('email') }]"
                  @click="set_invite_method('email')"
                >
                  <i class="bi bi-envelope"></i>
                  <span>Email</span>
                </button>
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('link') }]"
                  @click="set_invite_method('link')"
                >
                  <i class="bi bi-link-45deg"></i>
                  <span>Link</span>
                </button>
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('qr_code') }]"
                  @click="set_invite_method('qr_code')"
                >
                  <i class="bi bi-qr-code"></i>
                  <span>QR Code</span>
                </button>
              </div>

              <div v-if="invite_method_is('email')" class="organization-create-user-grid">
                <div>
                  <label class="form-label text-xxs fw-500 " for="invite_email">Email <span class="text-danger">*</span></label>
                  <input id="invite_email" v-model="invite_user.email" :class="['form-control rounded text-xxs', { 'is-invalid': invite_errors.email }]" type="email" placeholder="example@company.com" />
                  <div v-if="invite_errors.email" class="invalid-feedback text-xxs">{{ invite_errors.email }}</div>
                </div>
              </div>

              <div v-if="latest_invitation" :class="['organization-invite-share', { 'organization-invite-share-single': !invite_method_is('email') }]">
                <div v-if="!invite_method_is('qr_code')">
                  <p class="organization-invite-share-label">Invite link</p>
                  <div class="organization-invite-link-row">
                    <input class="form-control rounded text-xxs" :value="latest_invitation.link" readonly />
                    <div class="organization-invite-share-actions">
                      <button class="btn btn-light rounded border organization-share-icon-btn" type="button" title="Copy invite link" @click="copy_invitation_link">
                        <i class="bi bi-clipboard"></i>
                      </button>
                      <div class="dropdown organization-invite-share-menu">
                        <button
                          class="btn btn-light rounded border organization-share-icon-btn"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          title="Share invite link"
                        >
                          <i class="bi bi-three-dots"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end organization-invite-share-dropdown">
                          <a
                            :href="get_invitation_share_url('whatsapp')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-whatsapp text-success"></i>
                            <span>WhatsApp</span>
                          </a>
                          <a
                            :href="get_invitation_share_url('facebook')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-facebook text-primary"></i>
                            <span>Facebook</span>
                          </a>
                          <a
                            :href="get_invitation_share_url('linkedin')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-linkedin text-info"></i>
                            <span>LinkedIn</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!invite_method_is('link') && latest_invitation.qr_code" class="organization-invite-qr">
                  <img :src="invitation_qr_src()" alt="Organisation invite QR code" />
                  <div class="organization-invite-share-actions organization-invite-qr-actions">
                    <button class="btn btn-light rounded border organization-share-icon-btn" type="button" title="Download QR code" @click="download_invitation_qr">
                      <i class="bi bi-download"></i>
                    </button>
                    <div class="dropdown organization-invite-share-menu">
                      <button
                        class="btn btn-light rounded border organization-share-icon-btn"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        title="Share invite link"
                      >
                        <i class="bi bi-three-dots"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end organization-invite-share-dropdown">
                        <a
                          :href="get_invitation_share_url('whatsapp')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-whatsapp text-success"></i>
                          <span>WhatsApp</span>
                        </a>
                        <a
                          :href="get_invitation_share_url('facebook')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-facebook text-primary"></i>
                          <span>Facebook</span>
                        </a>
                        <a
                          :href="get_invitation_share_url('linkedin')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-linkedin text-info"></i>
                          <span>LinkedIn</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_inviting_member">
                {{ get_invite_submit_label() }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="add_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="addOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="addOrganizationMemberLabel">Add Organisation Members</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form class="organization-add-members-form" @submit.prevent="bulk_add_organization_members">
            <div class="modal-body organization-add-members-body">
              <div class="organization-member-modal-tabs" role="tablist" aria-label="Organisation member action">
                <button class="organization-member-modal-tab" type="button" role="tab" aria-selected="false" @click="open_invite_member_modal">
                  <i class="bi bi-envelope-plus" aria-hidden="true"></i>
                  <span>Invite</span>
                </button>
                <button class="organization-member-modal-tab active" type="button" role="tab" aria-selected="true">
                  <i class="bi bi-person-plus" aria-hidden="true"></i>
                  <span>Add Members</span>
                </button>
              </div>

              <div v-if="bulk_member_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ bulk_member_errors.form }}
              </div>

              <div class="d-flex justify-content-end mb-3">
                <button type="button" class="btn btn-sm btn-primary rounded text-xxs" @click="add_bulk_member_row">
                  Add more
                </button>
              </div>

              <div v-for="(member, index) in bulk_members" :key="index" class="border rounded p-3 mb-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <strong class="text-xxs">Member {{ index + 1 }}</strong>
                  <button
                    type="button"
                    class="btn btn-light board-icon-btn d-none d-xl-flex align-items-center justify-content-center me-2"
                    title="Remove member row"
                    aria-label="Remove member row"
                    @click="remove_bulk_member_row(index)"
                  >
                    <i class="bi bi-x-lg" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="organization-create-user-grid">
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_first_name_${index}`">First Name <span class="text-danger">*</span></label>
                    <input :id="`member_first_name_${index}`" v-model="member.first_name" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.first_name }]" type="text" placeholder="Enter first name" />
                    <div v-if="bulk_member_errors.members[index]?.first_name" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].first_name }}</div>
                  </div>
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_last_name_${index}`">Last Name <span class="text-danger">*</span></label>
                    <input :id="`member_last_name_${index}`" v-model="member.last_name" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.last_name }]" type="text" placeholder="Enter last name" />
                    <div v-if="bulk_member_errors.members[index]?.last_name" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].last_name }}</div>
                  </div>
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_email_${index}`">Email <span class="text-danger">*</span></label>
                    <input :id="`member_email_${index}`" v-model="member.email" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.email }]" type="email" placeholder="example@company.com" />
                    <div v-if="bulk_member_errors.members[index]?.email" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].email }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer organization-add-members-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_bulk_adding_members">
                {{ is_bulk_adding_members ? 'Adding...' : bulk_members.length > 1 ? 'Add Members' : 'Add Member' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="manage_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="manageOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="manageOrganizationMemberLabel">Manage Member Access</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="save_member_access">
            <div class="modal-body">
              <div v-if="selected_member" class="organization-manage-member-summary">
                <div class="organization-member-avatar">
                  <img v-if="get_member_profile_picture(selected_member)" :src="get_member_profile_picture(selected_member)" alt="Profile picture" />
                  <span v-else>{{ get_initials(selected_member) }}</span>
                </div>
                <div>
                  <h3>{{ selected_member.first_name }} {{ selected_member.last_name }}</h3>
                  <p>{{ selected_member.email }}</p>
                </div>
              </div>

              <div v-if="member_access_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ member_access_errors.form }}
              </div>

              <div class="organization-permission-list">
                <label class="form-label text-xxs fw-500">Permissions</label>
                <div v-if="organization_permissions.length" class="organization-permission-grid">
                  <label v-for="permission in organization_permissions" :key="permission.id || permission.code || permission.name" class="organization-permission-option">
                    <input class="form-check-input" type="checkbox" :value="permission.id || permission.code || permission.name" v-model="member_access.permission_ids" />
                    <span>
                      <strong>{{ permission.name || permission.permission || permission.code }}</strong>
                      <small v-if="permission.description">{{ permission.description }}</small>
                    </span>
                  </label>
                </div>
                <p v-else class="text-muted text-xxs mb-0">No organisation permissions are available.</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_saving_access">
                {{ is_saving_access ? 'Saving...' : 'Save Access' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</div>
